module.exports = __webpack_public_path__ + "media/assets/BannerIcon-8bcc399026627bc0b010a6cc2b669306.svg";